import React from "react";
import classNames from "classnames";

const Foundation = (props) => {
  return (
    <div className="bg-white rounded-lg shadow px-5 py-6 sm:px-6">
      <div className="rounded-lg">
        <div className="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
          <div className="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-no-wrap">
            <div className="ml-4 mt-2">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Vaccinator3000 Instructions
              </h3>
              <p className="mt-1 text-sm leading-5 text-gray-500">
                Use the "Run" button to the left. View available appointments
                below. Use the "Donate" button to support the tool!
              </p>
            </div>
            <div className="flex items-center space-x-3">
              <span
                role="checkbox"
                tabIndex="0"
                aria-checked="false"
                className={classNames(
                  "relative inline-block flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-none",
                  props.auto ? "bg-sprxBlue" : "bg-gray-200"
                )}
                onClick={() => {
                  var value = props.auto === true ? false : true;
                  props.onClickToggle(value);
                }}
              >
                <span
                  aria-hidden="true"
                  className={classNames(
                    "inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200",
                    props.auto ? "translate-x-5" : "translate-x-0 "
                  )}
                ></span>
              </span>
              <span id="toggleLabel">
                <span className="text-sm leading-5 font-medium text-gray-900">
                  Auto
                </span>
              </span>
            </div>

            <div className="ml-4 mt-2 flex-shrink-0">
              <span className="inline-flex rounded-md shadow-sm">
                <button
                  type="button"
                  className={classNames(
                    "text-white font-bold py-2 px-4 min-w-96 elevation-2 text-center rounded",
                    !props.disabled &&
                      "bg-blue-600 hover:bg-blue-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-700 active:bg-blue-700",
                    props.disabled &&
                      "bg-sprxGrey opacity-50 cursor-not-allowed"
                  )}
                  onClick={!props.disabled ? props.onClick : undefined}
                >
                  Find Me a Shot!
                </button>
              </span>
            </div>
            <div className="ml-4 mt-2 flex-shrink-0">
              <span className="inline-flex rounded-md shadow-sm">
                <button
                  type="button"
                  className="text-white font-bold py-2 px-4 min-w-96 elevation-2 text-center rounded bg-green-500 hover:bg-green-600 focus:outline-none focus:shadow-outline-green focus:border-green-700 active:bg-green-700"
                >
                  Donate
                </button>
              </span>
            </div>
          </div>
        </div>
        <div>{props.children}</div>
      </div>
    </div>
  );
};

export default Foundation;
